export default __webpack_public_path__ + "static/media/ESR.7352e2cc.jpg";